// Starts an OmniAuth request phase (the "Log in with Microsoft" button).
//
// Through omniauth 1.x this was a plain link: GET /auth/auth/<provider> was
// enough to begin the flow. That is exactly CVE-2015-9284 — any third-party
// page could point a victim's browser at that URL and silently start an auth
// handshake the victim never asked for. omniauth 2 closed it by allowing only
// POST on its request path, and omniauth-rails_csrf_protection additionally
// requires Rails' authenticity token on that POST.
//
// A link can no longer start the flow, so build and submit a real form. The
// login page is server-rendered through layouts/application.html.erb, which
// emits csrf_meta_tags, so the token is in the document by the time the button
// can be clicked.

// Devise mounts OmniAuth under its own `path`, which is 'auth' (see
// devise_for :users, path: 'auth'), hence the doubled segment.
const OMNIAUTH_REQUEST_PREFIX = '/auth/auth';

export const omniauthRequestPath = (provider) => `${OMNIAUTH_REQUEST_PREFIX}/${provider}`;

const csrfToken = () => document.getElementsByName('csrf-token')[0]?.content;

// Returns false when the CSRF token is missing, so the caller can tell the user
// rather than submitting a form the server is guaranteed to reject.
export const startOmniauthSignIn = (provider) => {
  const token = csrfToken();
  if (!token) return false;

  const form = document.createElement('form');
  form.method = 'POST';
  form.action = omniauthRequestPath(provider);

  const tokenInput = document.createElement('input');
  tokenInput.type = 'hidden';
  tokenInput.name = 'authenticity_token';
  tokenInput.value = token;
  form.appendChild(tokenInput);

  document.body.appendChild(form);
  form.submit();
  return true;
};
